import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';
import { PLATZHALTER_TEXT } from '../../../../lib/constants/constant';
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';

// import schemas
import Schema from '../../../../lib/paths/person_FULL_Paths.json';

const P = Schema.attributes;

const PersonDaten: FC<{ formValue: any; updateFunction: (_key: string, _value: any) => void; personDatenError: any }> = ({
	formValue,
	updateFunction,
	personDatenError,
}) => {
	return (
		<>
			<ApplicationHeading title='Persondaten' description={PLATZHALTER_TEXT} />

			<CreateForm
				formValues={formValue}
				formStruc={formStruc()}
				updateFormValuesFunc={updateFunction}
				formErrors={personDatenError}
				api={APIS.Person}
			/>
		</>
	);
};

export default PersonDaten;

const formStruc = () => {
	return [
		{
			fields: [
				// P.Personenbezogene_Daten_Anrede,
				P.Personenbezogene_Daten_Titel,
				P.Personenbezogene_Daten_Vorname,
				P.Personenbezogene_Daten_Nachname,
				P.Kontaktdaten_E_Mail,
				P.Kontaktdaten_Telefon,
				P.Adressdaten_Strasse_Und_Hausnummer,
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
};
